export default __webpack_public_path__ + "static/media/Hana the Hanukkah Fairy.5c2173ab.jpeg";